import {  LOGIN_API } from "../constants/api";
import { InvitationSendParamModel } from "../model/account";
import { LoginParamModel } from "../model/login";
import { getHeaders, getUrl, optionsPost } from "./commonService";
import customAxios from "./customAxios";

export default class LoginService {
  invitationSendService(params: InvitationSendParamModel) {
    throw new Error("Method not implemented.");
  }

  loginService(params:LoginParamModel) {
    const detail = {
      username: params.username,
      password: params.password
    };


    const url = getUrl(LOGIN_API.LOGIN);
    const headers = getHeaders(params.tenantName||"");
    const options:any = optionsPost(url, headers,detail);

    return customAxios(options).then((res) => {
      return res.data;
    });


  }
}
